import { render, staticRenderFns } from "./AllPersonsTurnoversReport.vue?vue&type=template&id=5907d6da&"
import script from "./AllPersonsTurnoversReport.vue?vue&type=script&lang=js&"
export * from "./AllPersonsTurnoversReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports